import { Observable } from 'rxjs';

export type SearchResponseType = Observable<void> | Promise<void | Observable<void>>;
